export const PURPOSES = {
	PERFORMANCE: 'c54', // Measurement → OneTrust C0002
	TRACKING: 'c52', // Marketing → OneTrust C0004
};
